// One definition of a valid hourly rate, shared by the Students page (link
// form + spreadsheet upload) and the Tutors page (Set Rate), which previously
// each kept their own copy of the R130-R240 rule.
//
// A tutor can have an approved exception to the ceiling, stored as
// tutors.max_hourly_rate (see
// supabase/migrations/20261013090000_tutor_max_hourly_rate.sql). The floor and
// the multiple-of-10 rule apply to everyone.

export const MIN_HOURLY_RATE = 130;
export const STANDARD_MAX_HOURLY_RATE = 240;

// Accepts a tutors row ({ max_hourly_rate }) or a page's mapped tutor
// ({ maxHourlyRate }). Anything missing falls back to the standard ceiling.
export const maxRateFor = (tutor) =>
  Number(tutor?.max_hourly_rate ?? tutor?.maxHourlyRate) ||
  STANDARD_MAX_HOURLY_RATE;

export const isValidHourlyRate = (
  value,
  maxRate = STANDARD_MAX_HOURLY_RATE,
) => {
  const rate = Number(value);
  return (
    Number.isInteger(rate) &&
    rate >= MIN_HOURLY_RATE &&
    rate <= maxRate &&
    rate % 10 === 0
  );
};

export const hourlyRateRule = (maxRate = STANDARD_MAX_HOURLY_RATE) =>
  `Must be between R${MIN_HOURLY_RATE} and R${maxRate} and a multiple of 10, e.g. 150 or 160.`;
